import { render } from "./HeaderSlide.vue?vue&type=template&id=b4883260&scoped=true"
import script from "./HeaderSlide.vue?vue&type=script&lang=js"
export * from "./HeaderSlide.vue?vue&type=script&lang=js"

import "./HeaderSlide.vue?vue&type=style&index=0&id=b4883260&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4883260"]])

export default __exports__